module.exports = __webpack_public_path__ + "img/e_3_12_r.c52e8bc6.png";